import React, { useEffect, useCallback, useState} from 'react';
import Screen from './Screen.js';
import ScriptTidals from "components/effects/scripting/ScriptTidals.js";
import DrumRouter from './DrumRouter.js';
import Figures from './Figures.js';
import {connect} from 'react-redux';
import '../../../Jaki.scss';

const JakiComponent = ({effect, track, sequencerEngine}) => { 
    let [chosen, setChosen] = useState(undefined);

    return (
        <div onClick={() => setChosen(undefined)} className="jaki">
          <div>
            <Screen setChosen={setChosen} chosen={chosen} effect={effect} track={track} sequencerEngine={sequencerEngine}/>
            <Figures setChosen={setChosen} chosen={chosen} effect={effect}/>
          </div>
          <div>
            <DrumRouter setChosen={setChosen} chosen={chosen} effect={effect}/>
            {effect.tidals && <ScriptTidals tidals={effect.tidals}/>}
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      tidals: props.effect.tidals
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JakiComponent);
